import React from "react";
import { learnerCountDisplay } from "../../../../utils/learnerCount";

const GettingStartedSection = () => (
  <section
    className="faqs"
    id="getting-started"
    aria-labelledby="getting-started-title"
  >
    <div className="container">
      <div className="section-head">
        <span className="section-num">01</span>
        <h2 className="section-title" id="getting-started-title">
          Getting <em>started</em>.
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>What exactly is 42courses?</summary>
          <div className="faq-answer">
            <p>
              42courses is an online learning platform offering{" "}
              <strong>40+ CPD-accredited Mini MBAs</strong> across four areas:
              Behavioural Science &amp; Psychology, Leadership &amp; Wellbeing,
              Marketing/Strategy/Sales, and AI &amp; Innovation. Each course is
              taught by a working practitioner (people like Rory Sutherland, Dan
              Ariely, Sir John Hegarty and Meik Wiking), not academics or actors
              reading a script.
            </p>
            <p>
              We have over {learnerCountDisplay().replace("+", "")} learners in 170+ countries, with an 80%
              completion rate against an industry average of around 10%.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Who is 42courses for?</summary>
          <div className="faq-answer">
            <p>
              Most learners are working professionals (marketers, strategists,
              leaders, designers, founders). We also have students,
              career-changers, retirees and the genuinely curious.{" "}
              <strong>
                If you want to think more clearly, communicate better, and stay
                sharp in a world that won't sit still
              </strong>
              , 42courses is built for you.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Do I need any prior experience?</summary>
          <div className="faq-answer">
            <p>
              No. Our courses are written in plain English and use real-world
              examples and templates rather than dense academic theory.{" "}
              <strong>
                If you're new to a topic, you'll quickly get up to speed.
              </strong>{" "}
              If you're senior, you'll likely pick up new tricks and inspiration
              from our thought leaders. Think of it as a faster, more enjoyable,
              more affordable MBA.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Can I try a course for free first?</summary>
          <div className="faq-answer">
            <p>
              Yes, we have <strong>a number of free sample courses</strong>. If
              you browse the <a href="/courses">courses page</a>, just look for
              the free sample tag. You'll find them on our home page too.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What's a Mini MBA, exactly?</summary>
          <div className="faq-answer">
            <p>
              Unlike a traditional MBA that takes months and costs a small
              fortune, our Mini MBAs are{" "}
              <strong>time-efficient and laser-targeted</strong>. You can finish
              one in a day if you push, or spread it out over a couple of weeks
              at a more leisurely pace.
            </p>
            <p>
              Like traditional MBAs, they favour practice over theory. Unlike
              traditional MBAs, you won't need to read thousands of dry academic
              papers to pass.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default GettingStartedSection;
